import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconHomeCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M10.6278 1.92459C11.4773 1.43554 12.5227 1.43554 13.3722 1.92459L19.6222 5.52307C20.4746 6.01388 21 6.92263 21 7.90629V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V7.90629C3 6.92263 3.52539 6.01388 4.37785 5.52307L10.6278 1.92459ZM8.75 12.25C8.75 10.4551 10.2051 9 12 9C13.7949 9 15.25 10.4551 15.25 12.25C15.25 14.0449 13.7949 15.5 12 15.5C10.2051 15.5 8.75 14.0449 8.75 12.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeCircle;
